import { CustomerLabel } from '../customer/customerLabel';
import { DsiSessionTracking } from '../dsi/dsiSessionTracking';
import { OtherString } from '../otherString';
import { PaymentMethod } from '../payment/payment';
import type { Range } from '../range';
import { RetainMarker } from '../retainMarker';
import { ClassificationClassName } from '../snapshot/classificationClass';
import { SnapshotStats } from './snapshotStats';
import { z } from 'zod';

export type SessionMetricsFilter = Partial<Record<keyof SessionMetrics, number | Range>>;
export type SessionImageClassFilter = Partial<Record<ClassificationClassName, number | Range>>;

export const SessionMetrics = z.object({
    bottleBundleChecks: z.number().nullish(),
});

export type SessionMetrics = z.infer<typeof SessionMetrics>;

export const CustomerSessionTracking = z.object({
    sessionGuid: z.string(),

    createdOn: z.coerce.date().nullish(),
    startedOn: z.coerce.date().nullish(),
    paymentCompletedOn: z.coerce.date().nullish(),
    endedOn: z.coerce.date().nullish(),
    modifiedOn: z.coerce.date().nullish(),
    filterDate: z.string().nullish(),

    customerGuid: z.string().nullish(),
    customerCard: z.string().nullish(),
    employeeCard: z.string().nullish(),
    hash: z.string().nullish(),
    labels: CustomerLabel.array().nullish(),

    items: z
        .object({
            guid: z.string().nullish(),
            itemId: z.string().nullish(),
            name: z.string().nullish(),
            brand: z.string().nullish(),
            code: z.string().nullish(),
            deposit: z.number().nullish(),
            discountCode: z.string().nullish(),
            price: z.number().nullish(),
            qty: z.number().nullish(),
            total: z.number().nullish(),
        })
        .array()
        .nullish(),
    paymentMethod: PaymentMethod.or(OtherString).nullish(),
    posIdEans: z.string().array().nullish(),
    storeGuid: z.string().nullish(),
    store: z
        .object({
            name: z.string().nullish(),
            street: z.string().nullish(),
            city: z.string().nullish(),
            country: z.string().nullish(),
            zipCode: z.string().nullish(),
        })
        .nullish(),
    total: z.number().nullish(),
    cartId: z.string().nullish(),

    receiptBarcode: z
        .object({
            type: z.string().nullish(),
            code: z.string().nullish(),
        })
        .nullish(),
    receiptTotal: z.number().nullish(),
    snapshots: SnapshotStats.nullish(),

    dsi: DsiSessionTracking.nullish(),

    metrics: SessionMetrics.nullish(),
    imageClassDetectionProbabilities: z.record(ClassificationClassName.or(OtherString), z.number().nullish()).nullish(),
    imageClassBasketCounts: z.record(ClassificationClassName.or(OtherString), z.number().nullish()).nullish(),
    retain: RetainMarker.nullish(),

    expectedWeight: z.number().nullish(),
    actualWeight: z.number().nullish(),
    weightDeviation: z.number().nullish(),
    isDemoModeOn: z.boolean().nullish(),
});

export type CustomerSessionTracking = z.infer<typeof CustomerSessionTracking>;
